import configSchema from './configSchema';
import AdapterType from '@jbrowse/core/pluggableElementTypes/AdapterType';
export default (function (pluginManager) {
  pluginManager.addAdapterType(function () {
    return new AdapterType({
      name: 'MultiWiggleAdapter',
      displayName: 'Multi-wiggle adapter',
      configSchema: configSchema,
      adapterCapabilities: ['hasResolution', 'hasLocalStats', 'hasGlobalStats'],
      adapterMetadata: {
        hiddenFromGUI: true
      },
      getAdapterClass: function getAdapterClass() {
        return import('./MultiWiggleAdapter').then(function (r) {
          return r.default;
        });
      }
    });
  });
});